import React from "react";
import { Button, Col, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";

const RenewModal = ({setIsRenew, token}: any) => {
  const navigate = useNavigate();

  const handleRenew = () => {
    if (!localStorage.getItem("USER_ID")) {
      console.error("Session expired: USER_ID not found");
      return;
    }
  
    if (token) {
      navigate(`/membership-checkout/${token}`);
      setIsRenew(false)
    } else {
      console.error("Token not found!");
    }
  };
  

  return (
    <div className="form-wrap">
      <Row className="gy-4">
        <Col lg={12}>
          <div className="modal-warning-text-wrap">
            <div className="warning-img-wrap">
              <img src="/images/circle-check-regular.svg" alt="warning-icon" />
            </div>
            <h5 className="modal-warning-title">MemberShip Renewal</h5>
            <small className="sub-text">Please renew you account!</small>
          </div>
        </Col>

        <Col lg={12}>
          <div className="submit-btn-wrap centered">
            <Button
              color={"danger"}
              outline
              className="sm"
              onClick={() => setIsRenew(false)}
            >
              Cancel
            </Button>
            <Button color={"primary"} className="sm" onClick={handleRenew}>
              Renew
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default RenewModal;